import linksRule from '../../link/default';

const dark = (params) => linksRule.dark(params);

export default dark;
